import React, { memo, useCallback } from 'react'

import { classnames, Icon, Upload2 } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { func } from 'prop-types'

import { iconSizeLarge, iconSizeMedium } from 'Pods/ThreeDStudio/constants'
import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'
import useThreeDModelUploader from 'Pods/ThreeDStudio/Shared/UploadThreeDModelButton/Hooks/useThreeDModelUploader'

import useBreakpoint from 'Utils/useBreakpoint'

function UploadTile({ onUploadStart }) {
  const t = useTranslation()
  const { acceptedExtensions, inputRef, isLoading, onFileChange, onFileClick } = useThreeDModelUploader()
  const label = t('threeDModelPicker.uploadTile')
  // Two cards to a row below 640px leaves the tile 93px tall at a 320px viewport, where
  // the desktop icon and body-md label overflow it - the longer translations wrap to two
  // lines. The tile steps down with the box it has to fit in.
  const isCompact = useBreakpoint() === 'xs'

  // The uploader takes over the viewer from here (banner, sidebar, notifications), so
  // the picker steps aside as soon as a file is chosen. A cancelled file dialog never
  // fires change, and so never closes the modal.
  const handleFileChange = useCallback((e) => {
    onFileChange(e)
    onUploadStart()
  }, [onFileChange, onUploadStart])

  return (
    <>
      <input
        ref={inputRef}
        type="file"
        accept={acceptedExtensions.map(ext => `.${ext}`).join(',')}
        onChange={!isLoading ? handleFileChange : undefined}
        aria-hidden
        tabIndex={-1}
        disabled={isLoading}
        style={{ display: 'none' }}
      />
      <button
        type="button"
        className="three-d-model-picker__card three-d-model-picker__card--upload"
        onClick={!isLoading ? onFileClick : undefined}
        disabled={isLoading}
      >
        <Icon svgComponent={Upload2} size={isCompact ? iconSizeMedium : iconSizeLarge} color="dark" notSpaced />
        <span
          className={classnames(
            'three-d-model-picker__card-label',
            isCompact ? 'cgt-body-base-semibold' : 'cgt-body-md-semibold',
          )}
        >
          {label}
        </span>
      </button>
    </>
  )
}

UploadTile.propTypes = {
  onUploadStart: func.isRequired,
}

export default memo(UploadTile)
